import { useState, useEffect } from 'react';
import { RecurringInvoiceStatsData } from '../../@types/invoice';
import { getRecurringInvoiceStats } from '../../backend-services';

interface ErrorType {
  message?: string;
}


export function useRecurringInvoiceStatsData(startDate: Date, endDate: Date) {
  const [recurringData, setRecurringData] = useState<RecurringInvoiceStatsData  | null>(null);
  const [error, setError] = useState<ErrorType | null>(null);
  const fetchData = async () => {
    try {
      const response = await getRecurringInvoiceStats(startDate.toISOString(), endDate.toISOString());
      const data: RecurringInvoiceStatsData = {
        totalActiveReoccurring: response.totalActiveReoccurring,
        totalPausedReoccurring: response.totalPausedReoccurring,
        totalCancelledReoccurring: response.totalCancelledReoccurring,
        totalExpiredReoccurring: response.totalExpiredReoccurring,
        dateRange: `${startDate.toDateString()} - ${endDate.toDateString()}`,
      };
      setRecurringData(data);
      setError(null);
    } catch (error) {
      setError({ message: 'Failed to fetch reccurring invoice statistics' });
      setRecurringData(null); 
    }
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]); 

  return { recurringData, error };
}
